webpackJsonp([22,20],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _keys = __webpack_require__(286);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _vue = __webpack_require__(252);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(284);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _app = __webpack_require__(209);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _index = __webpack_require__(293);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(292);
	
	var _index4 = _interopRequireDefault(_index3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var filters = __webpack_require__(296);
	
	(0, _keys2.default)(filters).forEach(function (k) {
	  _vue2.default.filter(k, filters[k]);
	});
	
	_vue2.default.use(_vueRouter2.default);
	
	_vue2.default.use(_index2.default);
	_vue2.default.use(_index4.default);
	
	var router = new _vueRouter2.default({
	  mode: 'hash',
	  routes: [{
	    name: 'index',
	    path: '/',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(0, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(219)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'product',
	    path: '/product',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(4, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(222)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    redirect: '/product/virtualscreen',
	    children: [{
	      path: 'virtualscreen',
	      component: function component(resolve) {
	        return __webpack_require__.e/* require */(8, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(229)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      }
	    }, {
	      path: 'md',
	      component: function component(resolve) {
	        return __webpack_require__.e/* require */(13, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(224)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      }
	    }, {
	      path: 'dock',
	      component: function component(resolve) {
	        return __webpack_require__.e/* require */(15, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(223)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      }
	    }, {
	      path: 'pharmacophore',
	      component: function component(resolve) {
	        return __webpack_require__.e/* require */(12, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(226)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      }
	    }, {
	      path: 'modeling',
	      component: function component(resolve) {
	        return __webpack_require__.e/* require */(19, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(225)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      }
	    }, {
	      path: 'training',
	      component: function component(resolve) {
	        return __webpack_require__.e/* require */(10, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(228)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      }
	    }, {
	      path: 'platform',
	      component: function component(resolve) {
	        return __webpack_require__.e/* require */(11, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(227)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      }
	    }]
	  }, {
	    name: 'custom',
	    path: '/custom',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(3, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(216)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    redirect: '/custom/cooperation',
	    children: [{
	      path: 'cooperation',
	      component: function component(resolve) {
	        return __webpack_require__.e/* require */(1, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(218)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      }
	    }, {
	      path: 'case',
	      component: function component(resolve) {
	        return __webpack_require__.e/* require */(9, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(217)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      }
	    }]
	  }, {
	    name: 'news',
	    path: '/news',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(5, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(220)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'newsdetail',
	    path: '/news/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(2, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(221)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'abouts',
	    path: '/abouts',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(6, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(210)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    redirect: '/abouts/company',
	    children: [{
	      path: 'company',
	      component: function component(resolve) {
	        return __webpack_require__.e/* require */(17, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(211)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      }
	    }, {
	      path: 'culture',
	      component: function component(resolve) {
	        return __webpack_require__.e/* require */(16, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(213)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      }
	    }, {
	      path: 'join',
	      component: function component(resolve) {
	        return __webpack_require__.e/* require */(14, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(215)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      }
	    }, {
	      path: 'contact',
	      component: function component(resolve) {
	        return __webpack_require__.e/* require */(7, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(212)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      }
	    }, {
	      path: 'faq',
	      component: function component(resolve) {
	        return __webpack_require__.e/* require */(18, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(214)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      }
	    }]
	  }]
	});
	
	router.beforeEach(function (to, from, next) {
	  window.scrollTo(0, 0);
	  next();
	});
	
	router.afterEach(function (to, from, next) {});
	
	var app = new _vue2.default({
	  el: '#app',
	  router: router,
	  render: function render(h) {
	    return h(_app2.default);
	  }
	});

/***/ }),

/***/ 197:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(197)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(297),
	  /* template */
	  __webpack_require__(239),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 239:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "bd-statistic",
	      rawName: "v-bd-statistic"
	    }],
	    attrs: {
	      "id": "appBody"
	    }
	  }, [_c('keep-alive', [_c('router-view')], 1)], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 292:
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (Vue) {
	    Vue.directive('bd-statistic', {
	        bind: function bind() {
	            var _hmt = _hmt || [];
	            var hm = document.createElement("script");
	            hm.src = "//hm.baidu.com/hm.js?70dd77fbe247aa71fd61c99fd02b6e34";
	            var s = document.getElementsByTagName("script")[0];
	            s.parentNode.insertBefore(hm, s);
	        }
	    });
	};

/***/ }),

/***/ 293:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function (Vue) {
	  var canUseWebp = document.documentElement.getAttribute('data-ext') == 'webp';
	  var isVueNext = Vue.version.split('.')[0] === '2';
	
	  function _update(el, option) {
	    var attr = option.arg || 'src';
	    if (el.tagName.toLowerCase() === 'img' && option.value) {
	      if (option.value.indexOf('data:image') < 0) {
	        el.setAttribute(attr, canUseWebp ? option.value + '.webp' : option.value);
	      } else {
	        el.setAttribute(attr, option.value);
	      }
	    } else if (option.modifiers.back && option.value) {
	      if (option.value.indexOf('data:image') < 0) {
	        el.style.backgroundImage = canUseWebp ? 'url(' + option.value + '.webp)' : 'url(' + option.value + ')';
	      } else {
	        el.style.backgroundImage = 'url(' + option.value + ')';
	      }
	    }
	  };
	
	  if (isVueNext) {
	    Vue.directive('webp', {
	      bind: function bind(el, binding) {
	        _update(el, {
	          arg: binding.arg,
	          modifiers: binding.modifiers,
	          value: binding.value
	        });
	      }
	    });
	  } else {
	    Vue.directive('webp', {
	      bind: function bind() {},
	      update: function update(val, old) {
	        _update(this.el, {
	          arg: this.arg,
	          value: val
	        });
	      },
	      unbind: function unbind() {}
	    });
	  }
	};

/***/ }),

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof2 = __webpack_require__(289);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _stringify = __webpack_require__(285);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;
	(function () {
		var s = window.localStorage;
		function set(key, value, filters) {
			if (key == undefined || value == undefined) return;
			if (typeof value != 'string') {
				value = (0, _stringify2.default)(value);
			}
			if (filters) {
				value = filter(value, filters);
			}
			s && s.setItem(key, value);
		}
		function get(key, type) {
			if (!key || !s) return null;
			var v = s.getItem(key);
			if (type == 'string') return v;
			return JSON.parse(v);
		}
		function remove(key) {
			if (!key || !s) return;
			s.removeItem(key);
		}
		function clear() {
			s && s.clear();
		}
		function toMd5(value) {
			if (value == undefined) return '';
			if (typeof value != 'string') {
				value = (0, _stringify2.default)(value);
			}
			if (!md5) return '';
			return md5(value);
		}
		function isChanged(key, newValue, filters) {
			var v = get(key);
			if (filters) {
				v = filter(v, filters);
				newValue = filter(newValue, filters);
			}
			var oMd5 = toMd5(v);
			var nMd5 = toMd5(newValue);
			return oMd5 != nMd5;
		}
	
		function filter(data, filters, type) {
			if (!data) return '';
			if (typeof data != 'string') {
				data = (0, _stringify2.default)(data);
			}
			if (!filters) return data;
			if (!(filters instanceof Array)) {
				filters = [filters];
			}
			var ndata = data,
			    len = filters.length,
			    filter;
			for (var i = 0; i < len; i++) {
				filter = filters[i];
				if ((typeof filter === 'undefined' ? 'undefined' : (0, _typeof3.default)(filter)) != 'object') continue;
				var reg = filter.reg,
				    value = filter.replacement;
				if (!(reg instanceof RegExp)) {
					reg = new RegExp(reg, 'gm');
				}
				if (value == undefined) value = '';
				ndata = ndata.replace(reg, function ($, $1) {
					var v = value;
					if (typeof $1 == 'string') {
						v = $.replace($1, value);
					}
					return v;
				});
			}
			if (type == 'object') {
				ndata = JSON.parse(ndata);
			}
			return ndata;
		}
		var miStorage = {
			get: get,
			set: set,
			remove: remove,
			clear: clear,
			isChanged: isChanged,
			filter: filter
		};
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return miStorage;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module != 'undefined' && module.exports) {
			module.exports = miStorage;
		} else {
			window.miStorage = miStorage;
		}
	})();

/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var isPro = !(false);
	var proConf = {};
	var devConf = {};
	
	var Rxports = {};
	
	module.exports = Rxports;

/***/ }),

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment, miStorage) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.filterPrice = filterPrice;
	exports.filterTime = filterTime;
	exports.filterDate = filterDate;
	exports.filterCdnDomain = filterCdnDomain;
	exports.mapStatusToManual = mapStatusToManual;
	
	var _config = __webpack_require__(295);
	
	var ONLINE = 'ONLINE';
	var PUT_ONLINE_VERIFYING = 'PUT_ONLINE_VERIFYING';
	var PUT_OFFLINE_VERIFYING = 'PUT_OFFLINE_VERIFYING';
	var UPDATE_APK_VERIFYING = 'UPDATE_APK_VERIFYING';
	var UPDATE_INFO_VERIFYING = 'UPDATE_INFO_VERIFYING';
	var DRAFT = 'DRAFT';
	var VERIFY_FAILED = ['PUT_ONLINE_VERIFY_FAILED', 'PUT_OFFLINE_VERIFY_FAILED', 'UPDATE_APK_VERIFY_FAILED', 'UPDATE_INFO_VERIFY_FAILED'];
	var OFFLINE = 'OFFLINE';
	function filterPrice(val) {
	  return '￥' + (val / 100).toFixed(2);
	}
	
	function filterTime(time) {
	  date = parseInt(date);
	  return moment(time).format('YYYY-MM-DD');
	}
	
	function filterDate(date) {
	  date = parseInt(date);
	  return moment(date).format('YYYY-MM-DD');
	}
	
	function filterCdnDomain(imgUrl, imageType) {
	  var domain = miStorage.get('config') && miStorage.get('config').cdn_domains || _config.cdn_domains;
	  if (!imgUrl) return '';
	  if (imageType == 1) {
	    return '' + domain.image + imgUrl;
	  }
	}
	
	function mapStatusToManual(status) {
	  switch (status) {
	    case ONLINE:
	      return '申请下架';
	    case PUT_ONLINE_VERIFYING:
	    case PUT_OFFLINE_VERIFYING:
	    case UPDATE_APK_VERIFYING:
	    case UPDATE_INFO_VERIFYING:
	      return '中止审核';
	    default:
	      return '';
	  }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(251), __webpack_require__(294)))

/***/ }),

/***/ 297:
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = {
		data: function data() {
			return {};
		},
		components: {},
		created: function created() {},
		directives: {}
	};

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.2c293eab6179f7e8d8b5.js